module.exports = __webpack_public_path__ + "img/logo-UMCP-tmp.a7c9fe32.svg";